/**
 * Created by Administrator on 2017/3/17.
 */
import { Injectable } from "@angular/core";
import { HttpHeaders, HttpClient, HttpParams } from "@angular/common/http";
import { Router } from "@angular/router";
import { StroageService } from "./stroage";
import { API } from "../config/api-config";
import "rxjs/add/operator/toPromise";

@Injectable()
export class HttpService {
  constructor(
    private http: HttpClient,
    private stroage: StroageService,
    private router: Router
  ) {}
  //设置请求头
  private headers = new HttpHeaders({
    "Content-Type": "application/json",
    token: this.stroage.getStroage("token")
      ? this.stroage.getStroage("token")
      : "",
  });

  /**
   *登录请求
   * @param data={"username": "string","password": "string"}
   * @returns string body
   */
  login(data: any): Promise<any> {
    return this.http
      .post(API.login, JSON.stringify(data), { headers: this.headers })
      .toPromise()
      .then((response) => {
        let res: any = response;
        try {
          if (res._body) {
            res = JSON.parse(res._body);
          }
        } catch (e) {}
        this.handleResponseCode(res.status.code);
        return res;
      })
      .catch(this.handleError);
  }
  /**
   * 获取数据
   * @param api  string
   * @param data json
   * @returns {any|Promise<*|T>|Promise<*>|Promise<R>}
   */
  getData(api: string, data?: any): Promise<any> {
    let headers = new HttpHeaders({
      "Content-Type": "application/json",
      token: this.stroage.getStroage("token")
        ? this.stroage.getStroage("token")
        : "",
    });
    let params = new HttpParams();
    if (!!data) {
      for (let i in data) {
        if (data[i] !== "" || data[i] === 0) {
          params = params.set(i, data[i]);
        }
      }
    }
    return this.http
      .get(api, { headers: headers, params: params })
      .toPromise()
      .then((response) => {
        let res: any = response;
        try {
          if (res._body) {
            res = JSON.parse(res._body);
            console.log(res.status.code);
          }
        } catch (e) {}
        this.handleResponseCode(res.status.code);
        return res;
      })
      .catch(this.handleError);
  }
  /**
   * 提交数据
   * @param api  string
   * @param data json
   * @returns respone
   */
  postData(api: string, data: any): Promise<any> {
    let headers = new HttpHeaders({
      "Content-Type": "application/json;charset=UTF-8",
      token: this.stroage.getStroage("token")
        ? this.stroage.getStroage("token")
        : "",
    });
    let body = JSON.stringify(data);
    return this.http
      .post(api, body, { headers: headers })
      .toPromise()
      .then((response) => {
        let res: any = response;
        try {
          if (res._body) {
            res = JSON.parse(res._body);
            console.log(res);
          }
        } catch (e) {}
        this.handleResponseCode(res.status.code);
        return res;
      })
      .catch(this.handleError);
  }

  /**
   * 删除数据
   * @param api string
   * @returns {Maybe<T>|Promise<*|T>|Promise<*>|any|Promise<R>}
   */
  deleteData(api: string): Promise<any> {
    let headers = new HttpHeaders({
      "Content-Type": "application/json",
      token: this.stroage.getStroage("token")
        ? this.stroage.getStroage("token")
        : "",
    });
    return this.http
      .delete(api, { headers: headers })
      .toPromise()
      .then((response) => {
        let res: any = response;
        try {
          if (res._body) {
            res = JSON.parse(res._body);
          }
        } catch (e) {}
        this.handleResponseCode(res.status.code);
        return res;
      })
      .catch(this.handleError);
  }

  public download(api: string, params: any): Promise<any> {
    let headers = new HttpHeaders({
      "Content-Type": "application/json",
      token: this.stroage.getStroage("token")
        ? this.stroage.getStroage("token")
        : "",
    });
    return this.http
      .get(api, { headers, params, responseType: "blob", observe: "response" })
      .toPromise()
      .then((res) => {
        console.log(res.headers);
        console.log(res.headers.get("Content-Disposition"));
        var fileName;
        try {
          fileName = res.headers
            .get("Content-Disposition")
            .split(";")[1]
            .trim()
            .split("=")[1];
        } catch (e) {
          fileName = new Date().getTime().toString();
        }
        fileName = fileName.replace(/^"/, "").replace(/"$/, "");
        console.log(fileName);
        var blob = res.body;

        var a = document.createElement("a");
        a.download = fileName;
        var bloburl = window.URL.createObjectURL(blob);
        a.href = bloburl;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);

        console.log(res);
      });
  }
  private handleError(error: any): Promise<any> {
    console.error("An error occurred", error);
    return Promise.reject(error.message || error);
  }

  /**
   * 处理code
   * @param code
   * @returns {any}
   */
  private handleResponseCode(code: any): Promise<any> {
    if (code == 401 || code == "401") {
      this.router.navigate(["/login"]);
    }
    return code;
  }
}



// WEBPACK FOOTER //
// /data/jenkins_data/workspace/NaturallyPlus_WEB_UAT/src/app/service/http-service.ts